import {
  UPGRADE_REPORT_API,
} from 'constants/AppConstants';

export default async (upgradeReportId) => {
  try {
    const response = await fetch(`${UPGRADE_REPORT_API}/${upgradeReportId}/upgrade`);
    const json = await response.json();
    if (response.status !== 200) return { ok: false, status: response.status, json };
    return { ok: true, status: response.status, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
